// extracted by mini-css-extract-plugin
export default {"galleryThumbnailList":"c-g_hs","galleryThumbnailList__wrapper":"c-g_ht"};